import {
    Box,
    Flex,
    VStack,
    HStack,
    Text,
} from "@chakra-ui/react";

import {
    useEffect,
    useState
} from "react";

import {
    useDispatch,
    useSelector,
} from "react-redux";

import Sidebar from "../../components/Sidebar";
import TopBar from "../../components/Topbar";
import PageHeader from "../Dashboard/components/PageHeader";
import NotificationsSkeleton from "./components/NotificationsSkeleton";
import EmptyState from "../../components/EmptyState";

import {
    getNotifications,
    markNotificationRead,
} from "../../state/actions/notificationActions";
import getIconConfig from "./components/IconConfig";

const Notifications = () => {
    const dispatch =
        useDispatch();
const [showSkeleton, setShowSkeleton] =
    useState(true);

useEffect(() => {
    const timer = setTimeout(() => {
        setShowSkeleton(false);
    }, 3000);

    return () => clearTimeout(timer);
}, []);
    const {
        notifications = [],
        loading,
    } = useSelector(
        state =>
            state.notifications
    );

    useEffect(() => {
        dispatch(
            getNotifications(
                null,
                null,
                1,
                100
            )
        );
    }, [
        dispatch,
    ]);



    const handleNotificationClick =
        async (
            notification
        ) => {
            if (
    notification.read_status !==
    "Read"
) {
                await dispatch(
                    markNotificationRead(
                        notification.notification_id
                    )
                );
            }
        };
    
        const handleMarkAllRead =
    async () => {
        for (const notification of notifications) {
            if (
                notification.read_status !==
                "Read"
            ) {
                await dispatch(
                    markNotificationRead(
                        notification.notification_id
                    )
                );
            }
        }
    };

    if (showSkeleton) {
    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <NotificationsSkeleton />
                </Box>
            </Flex>
        </Flex>
    );
}

    return (
       <Flex
    h="100vh"
    bg="#F8FAFC"
    overflow="hidden"
    marginBottom={{
        base: 20,
        md: 0,
    }}
>
            <Box
                w={{
                    base: 0,
                    md: "280px",
                }}
                flexShrink={0}
            >
                <Sidebar />
            </Box>

            <Flex
                flex="1"
                direction="column"
                overflow="hidden"
            >
                <TopBar />

                <Box
                    flex="1"
                    overflowY="auto"
                    p={{
                        base: 4,
                        md: 8,
                    }}
                >
                    <PageHeader
                        title="Notifications"
                        subtitle="View all system alerts, updates and account activity."
                    />
                  <Flex
    justify="flex-start"
    align="center"
    mt={2}
    mb={6}
>
                        <Text
                            color={
                                notifications.some(
                                    notification =>
                                        notification.read_status !==
                                        "Read"
                                )
                                    ? "#2453FF"
                                    : "gray.400"
                            }
                            fontSize="sm"
                            fontWeight="600"
                            cursor={
                                notifications.some(
                                    notification =>
                                        notification.read_status !==
                                        "Read"
                                )
                                    ? "pointer"
                                    : "not-allowed"
                            }
                            _hover={
                                notifications.some(
                                    notification =>
                                        notification.read_status !==
                                        "Read"
                                )
                                    ? {
                                        textDecoration:
                                            "underline",
                                    }
                                    : {}
                            }
                            opacity={
                                notifications.some(
                                    notification =>
                                        notification.read_status !==
                                        "Read"
                                )
                                    ? 1
                                    : 0.6
                            }
                            onClick={() => {
                                if (
                                    notifications.some(
                                        notification =>
                                            notification.read_status !==
                                            "Read"
                                    )
                                ) {
                                    handleMarkAllRead();
                                }
                            }}
                        >
                            Mark all as read
                        </Text>
                    </Flex>
                    {notifications.length === 0 ? (
                        <Flex
                            py={20}
                            justify="center"
                        >
                            <EmptyState
                                imageSize="180px"
                                title="No Notifications"
                                message="You're all caught up. New notifications and important updates will appear here."
                            />
                        </Flex>
                    ) : (
                        <VStack
                            gap={4}
                            align="stretch"
                        >
                            {notifications.map(
                                notification => {
                                    const config =
                                        getIconConfig(
                                            notification
                                        );

                                    const Icon =
                                        config.icon;

                                    return (
                                           <Flex
                                            key={notification.notification_id}
                                            direction={{
                                                base: "column",
                                                sm: "row",
                                            }}
                                            p={{
                                                base: 4,
                                                md: 6,
                                            }}
                                            bg={
                                                notification.read_status === "Read"
                                                    ? "white"
                                                    : "#F8FAFC"
                                            }
                                            borderRadius="20px"
                                            gap={4}
                                            cursor="pointer"
                                            onClick={() =>
                                                handleNotificationClick(notification)
                                            }
                                        >
                                            <Flex
                                                w="52px"
                                                h="52px"
                                                borderRadius="16px"
                                                bg={
                                                    config.bg
                                                }
                                                justify="center"
                                                align="center"
                                                flexShrink={0}
                                            >
                                                <Icon
                                                    size={22}
                                                    color={
                                                        config.color
                                                    }
                                                />
                                            </Flex>

                                            <Box flex="1">
                                                <HStack
                                                    justify="space-between"
                                                    mb={2}
                                                    align="start"
                                                >
                                                    <Text
                                                        fontSize="xs"
                                                        fontWeight="700"
                                                        color={
                                                            config.color
                                                        }
                                                        letterSpacing="1px"
                                                    >
                                                        {
                                                            notification.category ||
                                                            notification.notification_type ||
                                                            "SYSTEM"
                                                        }
                                                    </Text>

                                                    <Text
                                                        fontSize="sm"
                                                        color="gray.500"
                                                    >
                                                        {
                                                            notification.created_at
                                                        }
                                                    </Text>
                                                </HStack>

                                                <Text
                                                    fontWeight="700"
                                                    mb={2}
                                                    color="#071D54"
                                                >
                                                    {
                                                        notification.title
                                                    }
                                                </Text>

                                                <Text
                                                    color="gray.600"
                                                    lineHeight="1.7"
                                                >
                                                    {
                                                        notification.message ||
                                                        notification.description
                                                    }
                                                </Text>
                                            </Box>
                                        </Flex>
                                    );
                                }
                            )}
                        </VStack>
                    )}
                </Box>
            </Flex>
        </Flex>
    );
};

export default Notifications;